
export function AuthLoaderPage() {
  return <p>Loading User Informations</p>;
}
